module.exports = __webpack_public_path__ + "static/media/doe.389ccec8.png";